/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DisconnectBigCommerceRequest
 */
export interface DisconnectBigCommerceRequest {
  /**
   *
   * @type {string}
   * @memberof DisconnectBigCommerceRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the DisconnectBigCommerceRequest interface.
 */
export function instanceOfDisconnectBigCommerceRequest(
  value: object,
): value is DisconnectBigCommerceRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function DisconnectBigCommerceRequestFromJSON(
  json: any,
): DisconnectBigCommerceRequest {
  return DisconnectBigCommerceRequestFromJSONTyped(json, false);
}

export function DisconnectBigCommerceRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DisconnectBigCommerceRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function DisconnectBigCommerceRequestToJSON(
  json: any,
): DisconnectBigCommerceRequest {
  return DisconnectBigCommerceRequestToJSONTyped(json, false);
}

export function DisconnectBigCommerceRequestToJSONTyped(
  value?: DisconnectBigCommerceRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
